import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AnswerProfileSchema = withDefaults({
  type: 'answer-profile',
  objectExtensions: ['answer-profile'],
  fields: [
    {
      kind: 'attribute',
      name: 'providingApp',
    },
    {
      kind: 'attribute',
      name: 'academicDegree',
    },
    {
      kind: 'attribute',
      name: 'affordPayments',
    },
    {
      kind: 'attribute',
      name: 'currentForgivenessProgram',
    },
    {
      kind: 'attribute',
      name: 'currentWorkingOnForgiveness',
    },
    {
      kind: 'attribute',
      name: 'employmentType',
    },
    {
      kind: 'attribute',
      name: 'federalLoanTime',
    },
    {
      kind: 'attribute',
      name: 'householdIncome',
    },
    {
      kind: 'attribute',
      name: 'householdSize',
    },
    {
      kind: 'attribute',
      name: 'madeLimitedWaiverPayments',
    },
    {
      kind: 'attribute',
      name: 'madePayments',
    },
    {
      kind: 'attribute',
      name: 'payoffGoal',
    },
    {
      kind: 'attribute',
      name: 'planAsTeacher',
    },
    {
      kind: 'attribute',
      name: 'planInGovernment',
    },
    {
      kind: 'attribute',
      name: 'residenceState',
    },
    {
      kind: 'attribute',
      name: 'numberOfAdults',
    },
    {
      kind: 'attribute',
      name: 'numberOfChildren',
    },
    {
      kind: 'attribute',
      name: 'federalFirstLoanTime',
    },
    {
      kind: 'attribute',
      name: 'federalLastLoanTime',
    },
    {
      kind: 'attribute',
      name: 'teacherLoanForgiveness',
    },
    {
      kind: 'attribute',
      name: 'recertifiedIncomeAt',
    },
    {
      kind: 'attribute',
      name: 'consolidatedLoansAt',
    },
    {
      kind: 'attribute',
      name: 'changedRepaymentPlanAt',
    },
    {
      kind: 'attribute',
      name: 'accountDeclinedReason',
    },
    {
      kind: 'attribute',
      name: 'accountDeclinedComment',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: 'answerProfile',
      },
    },
  ],
});

export default AnswerProfileSchema;
